import { useCallback, useRef, useState } from 'react';

export function useImageLightbox() {
  const [image, setImage] = useState(null);
  const triggerRef = useRef(null);
  const closeButtonRef = useRef(null);

  const openLightbox = useCallback((imageData, triggerEl) => {
    triggerRef.current = triggerEl ?? document.activeElement;
    setImage(imageData);
  }, []);

  const closeLightbox = useCallback(() => {
    const trigger = triggerRef.current;
    setImage(null);
    requestAnimationFrame(() => {
      trigger?.focus?.();
    });
  }, []);

  return { image, openLightbox, closeLightbox, closeButtonRef };
}
